import styled from "styled-components";

export default styled.div(
  ({
    background = "var(--carter-faint)",
    direction = "row",
    placement = "center",
    align = "center",
  }) => ({
    position: "relative",
    display: "grid",
    height: "100%",
    width: "100%",
    background: background,
    gridAutoFlow: direction,
    placeItems: placement,
    alignContent: align,
  })
);
